<template>
    <div>
        <form-group :errors="inputErrors['new_time_estimated']">
            <label slot="label" for="time_estimated" class="col-sm-2 col-form-label required">{{ trans('tasks.actions.reestimate') }}</label>
            <div slot="field" class="worklog-datepicker">
                <div class="input-group">
                    <span class="input-group-addon"><icon :icon="'far fa-clock'"></icon></span>
                    <input type="text"
                           id="time_estimated"
                           class="form-control"
                           @change="$emit('newTimeEstimated', newTimeEstimated)"
                           v-model="newTimeEstimated">
                </div>
                <div class="help-block"><small>{{ trans('common.for_example_short') }} 3h 45m</small></div>
            </div>
        </form-group>

<!--        <form-group >-->
<!--            <label slot="label" for="comment" class="col-sm-2 col-form-label">{{ trans('tasks.comments.comment') }}</label>-->
<!--            <textarea slot="field" id="comment"  class="form-control" rows="8"></textarea>-->
<!--        </form-group>-->
    </div>
</template>

<script>

import FormGroup from '@/components/Forms/FormGroupHorizontal';
import Icon from '@/components/Icons/Icon';
import Datepicker from '@/components/DateTimepicker/Datepicker';
import Timepicker from '@/components/DateTimepicker/Timepicker';
import Alerts from "../../../../components/Alerts/Alerts";

export default {

    props: ['newTimeEstimated', 'inputErrors'],

    components: {Alerts, FormGroup, Icon, Datepicker, Timepicker},
};
</script>



// WEBPACK FOOTER //
// src/views/Tasks/Reschedule/Partials/Form.vue